import { render, staticRenderFns } from "./form-default.vue?vue&type=template&id=5b0dcf1e&scoped=true&"
import script from "./form-default.vue?vue&type=script&lang=js&"
export * from "./form-default.vue?vue&type=script&lang=js&"
import style0 from "./form-default.vue?vue&type=style&index=0&id=5b0dcf1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0dcf1e",
  null
  
)

export default component.exports